


function AccordianFunctionality() {

	$(document).find('.accordian .trigger').click(function() {
		$(this).closest('.content_section').toggleClass('show').find('.panel').slideToggle().toggleClass('show');
		$(this).closest('.content_section').find('.expand_icon').toggleClass('active');
	});
	
	$(document).find('.accordian .expand').click(function() {
		
		if( $(this).hasClass('close-all') ) {
			
			$(document).find('.panel').each(function() {
				$(this).slideUp();
				$(this).closest('.content_section').removeClass('show');

			});
			$('.expand_icon').removeClass('active');
			$(this).html('EXPAND ALL').removeClass('close-all');
			
		} else {
			
			$(document).find('.panel').each(function() {
				$(this).slideDown();
				$(this).closest('.content_section').addClass('show');
			});
			$('.expand_icon').addClass('active');
			$(this).html('CLOSE ALL').addClass('close-all');
			
		}
		
	});
	
}



$(document).ready(function() {

	PageSetup();

	var windowHeight;
	var windowWidth;
	var imageHeight;
	
	/* This function creates the home page panel. Does work with dynamic height (the new paragraph section) */
	function DesktopHomeSectionHeight() {
		windowHeight = $(window).height();
		imageHeight = $('.HomePage section .hero').height();
		var textHeightArray = [];
		var textHeight = 0;
		$('.HomePage section').height(windowHeight);
		$('.HomePage section .sectionText').each(function() {
			textHeightArray.push($(this).height());
		});
		textHeight = Math.min.apply(Math,textHeightArray);
		$('.HomePage section .sectionText').each(function() {
			$(this).css('top', windowHeight/2-textHeight/2-35);
		});
		$('.HomePage section .hero').css('bottom', -imageHeight);
	}

	function MobileHomeSectionHeight() {
		windowHeight = $(window).height();
		windowWidth = $(window).width();
		headerHeight = $('header').height()+47;
		sectionHeight = (windowHeight-headerHeight)/4;
		$('.HomePage section').height(sectionHeight);
		$('.HomePage section .sectionText').each(function() {
			var textHeight = $(this).height();
			$(this).css('top', sectionHeight/2-textHeight/2);
		});
	}

	function HomeSectionHover() {
		$('.HomePage section').mouseover(function() {
			imageHeight = $('.HomePage section img.hero').height();
			$(this).find('.hero').show().css('bottom', -imageHeight/5);
			if ($(this).attr('id') == 'section-1') {
				$('i.fa.fa-bars').css('color', '#012333');
			} else if ($(this).attr('id') == 'section-4') {
				$('#secondarynav ul li .fa, #secondarynav ul li, #secondarynav ul li a').css('color', '#012333');
			}
		}).mouseout(function() {
			$(this).find('.hero').css('bottom', -imageHeight);
			$('i.fa.fa-bars').css('color', '#fff');
			$('#secondarynav ul li .fa, #secondarynav ul li, #secondarynav ul li a').css('color', '#fff');
		});
	}

	function PageImageResize() {
		windowWidth = $(window).width();
		$('.intro-image img').width(windowWidth/2);
		imageHeight = $('.intro-image img').height();
		$('.intro-image').height(imageHeight);
	}

	function SecondaryMenuClick() {
		$('#secondarynav ul li').click(function() {
			$(this).siblings().find('.hoverContainer').hide();
			$(this).find('.hoverContainer').toggle();
			$('#SearchForm_SearchForm_Search').val('Search');
		});
		$('#secondarynav ul li .hoverContainer').click(function(e) {
			e.stopPropagation();
		});
	}

	function SearchClick() {
		$('#SearchForm_SearchForm_Search').focus(function() {
			$(this).val('');
		});
		$('#SearchForm_SearchForm_Search').blur(function() {
			if ($(this).val() == '') {
				$(this).val('Search');
			}
		});
	}

	function Desktop() {
		DesktopHomeSectionHeight();
		HomeSectionHover();
		PageImageResize();
		SecondaryMenuClick();
		SearchClick();
	}

	function Mobile() {
		MobileHomeSectionHeight();
		SecondaryMenuClick();
		SearchClick();
	}

	if ( $("html").hasClass("ie8") ) {
		if ($(window).width() > 1025) {
			Desktop();
		} else {
			Mobile();
		}
		$(window).resize(function() {
			if ($(window).width() > 1025) {
				Desktop();
			} else {
				Mobile();
			}
		});
	}

	$('.secondary-search').click(function() {
		$('input[name="Search"]').focus();
	});

	if( $(document).find('.accordian').length > 0 ){ AccordianFunctionality(); }
});


function PageSetup(){
    MobileNav();
    ToggleContent();
}

function MobileNav(){
    $('.hamburglar').click( function(){
        $(this).toggleClass('open');
        $('.mainnav').toggleClass('open');
        // $('.mainnav').slideToggle();
    });
}

// function ToggleContent(){
//     $('.toggle-button').click(function(e){
//         $(this).toggleClass('open');
//         e.preventDefault();
//         $(this).parent('.foo').parent('.togglable').children('.togglable-content').slideToggle(200);
//         $(this).parent('.foo').toggleClass('open');
//     });
// }

function ToggleContent(){
    $('.toggle-button').click(function(){
        $(this).parent('.togglable').children('.togglable-content').slideToggle(200);
        $(this).toggleClass('open');
    });
}